import React from 'react';
import Modal from '@common/components/Modal';
import FeedbackScreen, { RENTER_MOVED_OUT } from './modules/FeedbackScreen';
import userPersonas from '@common/constants/userPersonas';
import FindNewRenterScreen from './modules/FindNewRenterScreen';
import type { FeedbackInterface } from '@rental-manager/pages/Dashboard/types';

type Props = {
  propertyId: string;
  address: string;
  onlyOneTerm: boolean;
  submitFeedback: (args: string) => void;
  goToDashboard: () => void;
  onClose: () => void;
};

type State = {
  feedback: FeedbackInterface;
  showFindNewRenterScreen: boolean;
};

class StopPaymentsFeedbackPage extends React.Component<Props, State> {
  static defaultProps = {
    propertyId: '',
    address: '',
    onlyOneTerm: true,
    submitFeedback: () => {},
    goToDashboard: () => {},
    onClose: () => {},
  };

  constructor(props) {
    super(props);

    this.state = {
      feedback: RENTER_MOVED_OUT,
      showFindNewRenterScreen: false,
    };
  }

  chooseFeedback = (feedback: FeedbackInterface): void => {
    this.setState({ feedback });
  };

  submitFeedback = () => {
    this.props.submitFeedback(this.state.feedback.value);

    if (this.props.onlyOneTerm && this.state.feedback === RENTER_MOVED_OUT) {
      this.setState({ showFindNewRenterScreen: true });
      return;
    }

    this.props.goToDashboard();
  };

  render(): React.ReactNode {
    const { propertyId, address } = this.props;
    const modalHeader = this.state.showFindNewRenterScreen ? 'POST YOUR RENTAL' : 'PAYMENT SETTINGS';

    return (
      <Modal
        persona={userPersonas.LANDLORD}
        header={modalHeader}
        onRequestClose={this.props.onClose}
        dataAutoTestId="landlord-stop-payments-feedback"
      >
        {this.state.showFindNewRenterScreen ? (
          <FindNewRenterScreen propertyId={propertyId} />
        ) : (
          <FeedbackScreen
            address={address}
            feedback={this.state.feedback}
            onChoose={this.chooseFeedback}
            onSubmit={this.submitFeedback}
          />
        )}
      </Modal>
    );
  }
}

export default StopPaymentsFeedbackPage;
